import Vue from 'vue';
import Vuex from 'vuex';
import { ajaxPost } from '../utils/ajax';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    dictionaryData: [], // 字典
    config: {}, // 配置
    isShowConsult: false, //是否显示温馨提示弹窗
  },
  mutations: {
    // 字典列表
    handleDictionary(state, dictionaryData) {
      state.dictionaryData = dictionaryData;
    },
    // 配置
    handleWebsiteConfig(state, config){
      state.config = config;
    },
    //切换了解更多弹窗显示
    handleShowConsult(state, isShowConsult){
      state.isShowConsult = isShowConsult
    }
  },
  actions: {
    // 获取字典
    async fetchDictionary({ commit }){
      try {
        ajaxPost({
          url: 'dict/list',
          params: {},
          success(res){
            const { data } = res;
            commit('handleDictionary', data);
          }
        });
      } catch (e) {
        this.$message.warning(e);
      }
    },
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js